export default __webpack_public_path__ + "static/media/banner-1-new.d0a3b2da.jpg";